module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A")])]), _vm._v(" wave broke and rolled across the white sandy beach, the warm water bubbling around Kyra Morgan’s feet before receding back into the Gulf of Mexico. The sun peeked over the tops of the palm trees behind her, flooding the day with light. Her favorite time, at dawn when all was still right with the world. Before her day began.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The screech of a seagull pierced the tranquillity. A momentary disturbance until everything went back to a calmness that she’d needed after spending six straight years establishing Guardians, Inc. into a premier international company of female bodyguards. Drawing in a soothing breath, she relished the scent of the sea mingling with the sweet fragrance of the flowers her dad had planted right before his death a few years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This was her time to rest and relax. One week in Flamingo Cay, Florida, where she’d grown up. One week of no work. No emergencies. No—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A click and muffled pop invaded her tranquillity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sounds she’d heard as a police officer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pivoted, her survival instinct kicking into play as she raced to her beach bag a few yards away. When she reached it, she plunged her hand inside and grasped the handle of her Glock while panning the house next "), _c('a', {
    attrs: {
      "id": "page08"
    }
  }), _vm._v("door where the sound of a gun with a silencer going off had come from.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another pop invaded the early-morning quiet. She started moving toward the noise. Every sense locked on finding the source of the danger.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly a young man burst out of the hibiscus hedge edging the neighbor’s property, staggering toward her, his face clenched in pain. He clutched his stomach, blood pouring out between his fingers. Stopping, he fell to his knees, a plea in his eyes as they homed in on Kyra.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Help us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Us? Kyra glanced around as she covered the short distance to the young man. He collapsed to the sand, his eyes wide-open, giving her the dead man’s stare she’d seen countless times as a homicide detective. She felt for his pulse and found none.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pulled her cell from her shorts pocket and dialed 911. “Shots have been fired at 523 Pelican Lane. One man down—dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another shot, coming from inside the house, sent a spurt of adrenaline through her veins. “Hurry.” She disconnected, stuffed her phone into her pocket and ran toward the neighbor’s back deck—the sliding glass door was partially open. The house was up for sale. She’d noticed the sign out front when she’d arrived yesterday evening. She hadn’t thought anyone was living there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Every nerve tingled with the threat of danger, but she couldn’t get the young man’s plea out of her mind. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Help us.")]), _vm._v(" Who else was in trouble?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she neared the back that faced the water, she slowed, scanning the overgrown yard. The place had a vacant look to it, with no furniture on the deck. She ascended the stairs and crept toward the sliding glass door. Through it she looked inside. Totally empty.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page09"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she stepped over the threshold into the living room, a large expanse of taupe-colored tiles, her heartbeat accelerated. She paused and listened for any noise that indicated where the killer was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Another pop echoed through the vacant house, coming from the hallway that led to the bedrooms. A scream cleaved the air. The sound of pounding footsteps racing down the corridor toward Kyra propelled her into action. She flattened herself against the wall, her gun up, her total concentration on the opening. Heart hammering against her rib cage, she waited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A teenage girl burst out of the hall and darted across the room, blood on her hands and shirt, her features chiseled in fear. She glimpsed Kyra out of the corner of her eye and gasped, momentarily slowing. Their gazes connected for a few seconds. Kyra put her forefinger to her lips to indicate she keep quiet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The intrusion of a deep gravelly voice saying, “You can’t get away from me,” leached the rest of the color from the teen’s face. Her eyes grew huge. She sped toward the exit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra focused on the entrance into the living room while the racing footsteps of the girl resonated through the air. From the hallway a shot sounded, shattering the glass in the door. She glanced toward the girl to see her disappear down the stairs and into the backyard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Any second she expected to see the killer burst into the living room to hunt down the teen and finish her off. Kyra stiffened, every muscle primed for action.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Five heartbeats later she knew something was wrong. She inched closer to the edge of the wall to peer into the corridor. The thundering in her head pulsated through her mind, sending out an alarm. One, two deep breaths and "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("she swiveled out into the entrance, her Glock pointing toward the bedrooms. Emptiness taunted her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Followed by a sliver of fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had the killer sensed she was there waiting for him to appear? Did the girl’s gasp alert him? Maybe. Was he now lying in wait for her somewhere down this hall? Or did he flee out another way and was doubling around the house to go after the girl?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Each possibility only reinforced the peril. Kyra eased down the hall, approaching each room with caution. After a visual check from the doorway, she continued her search until she reached the last bedroom, its entrance wide-open. The silence lured her forward, at the same time cautioning her against the action.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The memory of the fright on the teen’s face propelled her toward the room. The girl was no match for a killer. Swinging into the bedroom, every sense homed outward, she scanned the area. A young man lay face up, his eyes closed, his chest barely rising and falling. Blood pooled on the tile floor by him, in front of an open sliding glass door, as a soft breeze blew the curtains.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Had the killer already escaped? Or was he in the bathroom or closet? She slunk along the wall to the first door and threw it wide. After inspecting the empty closet, she quickly moved on. At the bathroom, the door was ajar, and she nudged it farther open. As soon as she assessed no threat, she hurried to the man on the floor to see if there was anything she could do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tattoos covering both arms and an elaborate black dagger inked on his neck, the victim, probably between eighteen and twenty-two, wore blue jeans, the bottoms encrusted with wet mud, and a snow-white T-shirt, now saturated with blood from multiple shots to his gut. In her line of work she’d seen lethal wounds. This was one of them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She placed another call to 911 to let them know a person was critically injured in the bedroom of the vacant house and the shooter had fled the scene possibly pursuing a potential witness. As she hung up, a flash caught her attention out of the corner of her eye. Leaping to her feet, she saw a man dressed in camouflage plunge into the thick underbrush on the right side of the house—into the thicket that led to the swamp nearby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Was he going after the girl to finish her off?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kyra couldn’t let that happen. She’d done all she could for the young man, but maybe she could protect the teenage girl from getting killed, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She rushed out onto the small deck at the side of the house and scoured the area for any sign of an accomplice or the witness, then followed the assailant into the tangle of vegetation.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Dr. Michael Hunt scrubbed his hands down his face, trying to keep awake after pulling an all-nighter with a patient, a mother who finally delivered her baby boy at 5:13 a.m. this morning. Pouring his third mug of coffee, he wandered toward his bedroom to change, so he could turn around and go back to the clinic for today’s appointments. At least his partner would be back from vacation to help take some of the load off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blare of a siren halted Michael’s progress. He glanced toward the front of his house. The sound grew closer. Curiosity led him toward the entryway. He opened his door as two police cars passed his home on Pelican Lane and came to a stop five houses down from his place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The old Patterson house? Was someone hurt? No one lived there. Hadn’t for the past six months, according to his kid sister, Amy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard the click of the back door and swiveled "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v("around, catching a glimpse of his youngest sister hurrying down the hallway. What was Amy doing up so early? She wasn’t a morning person. He started forward to find out where she’d been when the shrill ring of his phone sliced through the silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not far from the table in the entryway where it sat, he snatched up the receiver. “Hello.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dr. Hunt, this is Officer Wilson with Flamingo Cay Police. A man is injured at the Pattersons’ place. He was shot. An ambulance won’t get here for at least fifteen more minutes from Clear Springs. Since you only live—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll be there.” Michael grabbed his black bag from a chair nearby and headed out the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The urgency in the officer’s voice prodded him to quicken his pace. As he neared the vacant house, Levi Wilson came around from the side, a frown on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He waved Michael toward him. “There’s a dead man on the beach, but there’s one in the bedroom alive. Barely.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shot where?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In the gut.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael rushed up the steps to the small deck on the side of the house. Just inside the sliding glass door lay a young man, faceup. He’d seen his fair share of fatal gunshot wounds. This one looked bad.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael knelt on the tile floor next to the injured young man who moaned, fixing his eyes on Michael. The young man’s eyes fluttered right before his head lolled to the side and the breath went out of him.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("In seconds, Kyra plunged into the wooded area and found herself ankle-deep in muddy water, a tangle of green vegetation hemming her in. Up ahead, she spotted movement and pressed ahead, branches clawing at her. Sweat coated her face. The realization that she didn’t know "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("which way the young girl had gone hastened her pace, even though the soggy ground weighed each step down. She couldn’t let the killer add another victim to his list.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she progressed, she spied the trampled bushes and vines where the assailant had run through. Then suddenly she came out onto a path with boot prints, about size eleven, which headed toward the canal. If she could remember correctly, the old pier people in the neighborhood used was in that direction—at least it had when she’d been growing up in Flamingo Cay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quickening her pace, she kept combing the area for any sign the killer had deviated from the trail. In the background she heard sirens coming closer but decided to keep going after the assailant. Deep into the green jungle of plants, her old fear began to encroach in her mind, robbing her of her full concentration. She nearly tripped over a half-buried log, managing at the last second to steady herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A muzzled pop sounded, followed immediately by a bullet whistling by her ear. She ducked behind a cypress not far from the path. With the loud beating of her heart vying with the drone of the insects, she peeked around the tree. Another pop echoed through the swamp. Splinters of bark flew off the cypress. She waited a minute, inching toward the other side of the large tree. Aiming high in case the girl was nearby, Kyra squeezed off several shots.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The noise of a motor revving came from the canal. Kyra peered in that direction. Through the foliage she saw a motor boat pull away. She hurried toward the old pier about twenty yards away. By the time she got to the bank of the water, the craft had disappeared around a bend going south.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Breathing hard, she bent over and tried to fill her "), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("lungs with oxygen. From behind her sloshing footsteps announced she had company. She straightened, bringing her gun up, and whirled to face any new threat.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e184da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter-01.vue
// module id = 69
// module chunks = 0